<template>
  <v-main class="px-0 py-2">
    <v-divider />
    <div class="py-4">
      <div class="mb-2">
        Locations
        <div class="caption">
          Please add up to 5 locations
        </div>
      </div>

      <v-card
        v-for="(location, key) in formattedLocation"
        :key="`location${key}`"
        class="mb-3"
      >
        <v-card-title class="justify-space-between pb-0">
          <span class="body-1 font-weight-bold">
            Location {{ key + 1 }}
            <span
              v-if="key === 0"
              class="caption"
            >
              (Primary location)
            </span>
          </span>

          <v-btn
            color="error"
            text
            :disabled="!editFlag"
            @click="deleteLocation(key)"
          >
            Remove
          </v-btn>
        </v-card-title>
        <v-card-text>
          <LocationEditor
            :key="`Country${key}`"
            :locations.sync="formattedLocation"
            :countries="countries"
            :order="key"
            :location-country.sync="location.country"
            :location-region.sync="location.region"
            :location-city.sync="location.city"
            :location-temp.sync="location.temp"
            :edit-flag="editFlag"
          />
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn
            class="mb-3"
            outlined
            :disabled="!location.temp || !editFlag"
            @click="$emit('location-save')"
          >
            {{ location.temp ? 'Save location' : 'Saved' }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <div class="text-center">
        <v-btn
          outlined
          :disabled="!editFlag"
          @click="addLocation"
        >
          Add new location
        </v-btn>
      </div>
    </div>
    <v-divider />
  </v-main>
</template>

<script>
import coachApi from '@/api/coach-profile/coach';
import LocationEditor from './LocationEditor.vue';

export default {
  name: 'Locations',

  components: {
    LocationEditor,
  },

  props: {
    editFlag: {
      type: Boolean,
      default: false,
    },

    locations: {
      type: Array,
      default: null,
    },
  },

  data: () => ({
    countries: null,
  }),

  computed: {
    formattedLocation: {
      get() {
        return this.locations;
      },
      set(newValue) {
        this.$emit('update:locations', newValue);
      },
    },
  },

  created() {
    this.getCountries();
  },

  methods: {
    async getCountries() {
      try {
        this.countries = await coachApi.getCountries();
      } catch (err) {
        console.log(err);
        this.$toast.error(err.msg || err.message);
      }
    },

    addLocation() {
      if (this.locations.length < 5) {
        this.$emit('update:locations', [
          ...this.locations,
          {
            country: null,
            region: null,
            city: null,
            temp: true,
          },
        ]);
      } else {
        this.$toast.warning('You cannot add more than 5 locations');
      }
    },

    deleteLocation(index) {
      const filtered = this.locations.filter((el, key) => key !== index);
      this.$emit('update:locations', filtered);
    },
  },
};
</script>
